/* eslint-disable @typescript-eslint/no-explicit-any */
import { get, post, put, handleClientError } from '../lib'

import { SearchJobsBody } from '../../pages/JobQueue/types'

interface ResponseType {
  id: string
  analyzer: {
    id: string
    name: string
  }
  result_id: string
  status: string
  exit_message: string
  progress_message: string
  progress_percent: string
  started_at: string
  finished_at: string
  created_at: string
  updated_at: string
}

export const getAllJobs = async (
  query: {
    [k: string]: string | number
  } = {}
): Promise<ResponseType[]> => {
  return get<ResponseType[]>({
    path: '/ipa/job',
    query
  })
}

export const getJob = async (id: string): Promise<ResponseType> => {
  return get<ResponseType>({
    path: `/ipa/job/${id}`
  })
}

export const createJob = async (
  analyzer_id: string,
  type = 'manual'
): Promise<{
  type: string
  analyzer_id: string
}> => {
  return post<
    {
      type: string
      analyzer_id: string
    },
    {
      type: string
      analyzer_id: string
    }
  >({
    path: '/ipa/job',
    body: { type: type, analyzer_id: analyzer_id }
  })
}

export const cancelJobs = async (ids: string[]): Promise<string[]> => {
  return put<string[], string[]>({
    path: '/ipa/job',
    body: ids
  })
}

export const searchJobs = async (
  body: SearchJobsBody
): Promise<SearchJobsBody> => {
  return post<SearchJobsBody, SearchJobsBody>({
    path: '/ipa/job/search',
    body
  })
}

export const removeJobs = async (ids: string[]): Promise<string[]> => {
  return post<string[], string[]>({
    path: '/ipa/job/remove',
    body: ids
  })
}
